<template>
  <i-box :selected="selected">
    <span slot="title">
      <div class="arrow arrow-left" @click="onClickPrevious()">
        <i class="fa fa-arrow-circle-left"></i>
      </div>
      <div class="arrow arrow-right" @click="onClickNext()">
        <i class="fa fa-arrow-circle-right"></i>
      </div>
      <div class="unit-title">
        <span class="label pull-right" :class="unitClass">{{ unit }}</span>
        <h5>{{ period }}</h5>
      </div>
    </span>
    <span v-if="processStats.length" slot="content">
      <h1 class="no-margins">{{ Math.round(received).toLocaleString() }}</h1>
      <div
        class="stat-percent font-bold text-success"
        :class="{ 'text-success': growth > 0, 'text-danger': growth < 0 }"
      >
        {{ Math.round(growth) }}%
        <i
          class="fa"
          :class="{ 'fa-level-up': growth > 0, 'fa-level-down': growth < 0 }"
        ></i>
      </div>
      <small>{{ description }}</small>
      <div class="sparkline">
        <trend :data="processStats" :gradient="['#683090', '#c97eff']" :height="60" auto-draw></trend>
      </div>
    </span>
    <span v-else slot="content">
      <slot name="content-loader"></slot>
    </span>
  </i-box>
</template>

<script>
import Trend from 'vuetrend';

import IBox from '@/components/common/IBox';

export default {
  name: 'AnalyticsUnitBlock',
  components: {
    Trend,
    IBox,
  },
  props: {
    unit: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    received: {
      type: Number,
      default: 0,
    },
    growth: {
      type: Number,
      default: 0,
    },
    stats: {
      type: Array,
      default: () => [],
    },
    period: {
      type: String,
      required: true,
    },
    unitClass: {
      type: String,
      default: 'label-success',
    },
    selected: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    processStats() {
      // Always start at 0, and create a clean array of totals
      return [0].concat(this.stats.map(stat => stat.total));
    },
  },
  methods: {
    onClickPrevious() {
      this.$emit('previous');
    },

    onClickNext() {
      this.$emit('next');
    },
  },
};
</script>

<style type="text/scss">
.sparkline {
  height: 60px;
}
.arrow {
  position: absolute;
  cursor: pointer;
  opacity: 0.4;
  top: 9px;
  font-size: 22px;
}
.arrow:hover {
  color: #683090;
  opacity: 1;
}
.arrow-left {
  left: 20px;
}
.arrow-right {
  right: 20px;
}
.unit-title {
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// AnalyticsUnitBlock.vue?6b92cce5